export default {
  'Screenshot': 'Print de Tela',
}